import styled from "@emotion/styled";
import {
  SortableCustomTable,
  Text,
} from "@totalenergiescode/mobility-business-rev-design-system";

export const StyledAccountsDetailsTidHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const StyledAccountsDetailsTidContainerDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const StyledTableContainerDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const StyledSortableCustomTable = styled(SortableCustomTable)`
  margin: 0;
`;

export const StyledCountText = styled(Text)`
  color: ${({ theme }) => theme.palette.grey[500]};
  text-align: center;
`;

export const StyledAddButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
`;
